/*
* @Author: LiuMouLiang
* @Date:   2023-04-04 16:22:03
* @class:  基础方法
toJson
trace
*/
import {
    _for,
    _noValue,
    _getStr,
    getObjVal,
    typeOf,
    findTarget,
    awaitTo,
    getOneObj,
} from 'tools';
import {
    findTargetToPageSettings,
    getFrontControlInfoToProductMsg,
} from './works';

export const bind_alert_fillImg = function(src, callback){
    return this.$alert(`<img class="fillImg" src="${src}" />`, {
        dangerouslyUseHTMLString: true,
        showConfirmButton: false,
        showCancelButton: true,
        closeOnClickModal: true, //是否可通过点击遮罩关闭 MessageBox
        cancelButtonText: '关闭',
        customClass: 'previewImg-popup-wraper',
        callback,
    });
};

export const getData_pageSettings = function(){
    let res = [];
    res = this.pageSettings || [];
    if(!res.length){
        res = this.pageSettingsSortedByIndex || [];
    };
    if(!res.length) {
        let frontControlInfo = this.frontControlInfo || {};
        if(!typeOf(frontControlInfo, 'object')){
            const productMsg = this.productMsg;
            frontControlInfo = getFrontControlInfoToProductMsg(productMsg);
        }
        if(typeOf(frontControlInfo, 'object')){
            res = getObjVal(frontControlInfo,'pageSettings') || [];
        }
    };
    return res;
};

export const findTarget_pageSettings = function(prop, ID){
    const Fn = getObjVal(this, 'getData_pageSettings');
    let res = {};
    if(Fn) {
        res = findTargetToPageSettings({
            prop,
            ID
        }, Fn()) || {};
    };
    return res;
};

/* 错误信息处理 */
export const errMsg_handle = async function(err, callback){
    const errStatus = getObjVal(err, 'data.status');
    // errStatus === -1 不提示弹窗
    if(err && err.msg && errStatus !== -1){
        this.bridge_hideLoading && this.bridge_hideLoading();
        if(errStatus === 1) { // 饿了么提示弹窗
            // this.$message.error(info);
            //this.$confirm
            this.$alert(err.msg, {
                confirmButtonText: '知道了',
                type: "error",
            });
        } else if(!errStatus) { // 无值为默认 - toast提示
            this.$tipsMessage(err.msg, 3);
        };
        // 后续特殊处理
        return callback && callback(err);
    };
};


// productId获取方式太多，值的类型也可能不一致
export const getData_productId = function(){
    let productId = getObjVal(this.globalControlConfig, 'productId'); //新的
    if(!productId) {
        productId = getObjVal(this.params, 'productId') //兼容
            || getObjVal(this.productMsg, 'productId') //老的
            || this.productId; //兼容
        productId = _getStr(productId);
    }
    return productId;
};

export const $openWindow = async function(attempts = 0){
    let payWindow = null;
    try{
        payWindow = window.open("/insurance-group-pc-new/#/payWait", '_blank');
        if (payWindow && payWindow.location) {
            return payWindow;
        } else {
            throw new Error('弹窗授权失败，无法唤起支付弹窗');
        };
    }catch(error){
        if(!attempts) {
            const [ alertErr, alertData ] = await awaitTo(this.$alert('弹窗授权失败，无法唤起支付弹窗，请点击“授权”再次唤起支付弹窗', {
                confirmButtonText: '授权',
                showClose: false,
                type: "warning",
            }));
            if(alertData === 'confirm') {
                payWindow = await $openWindow(attempts+1);
            }else{
                console.error('新窗口授权失败', error);
            };
        };

        if(!payWindow) {
            payWindow = {
                location: window.location,
                close: function(){
                    console.log('关闭新窗口');
                    // window.close();
                }
            };
        };
        return payWindow;
    };
};



// WEBPACK FOOTER //
// ./src/libs/util/bindThis.js